import { render, staticRenderFns } from "./add_team.vue?vue&type=template&id=254b4eb4&scoped=true&"
import script from "./add_team.vue?vue&type=script&lang=js&"
export * from "./add_team.vue?vue&type=script&lang=js&"
import style0 from "./add_team.vue?vue&type=style&index=0&id=254b4eb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254b4eb4",
  null
  
)

export default component.exports